import styled from "@emotion/styled"
import { docketTheme } from "theme"

export const EnvIndicatorContainer = styled.div`
  pointer-events: none;
  text-align: center;
  vertical-align: middle;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`

export const Container = styled.div`
  position: relative;
`

export const Corner = styled.div<any>`
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.8rem;
    height: 4.8rem;
    bottom: -10rem;
    right: 1.2rem;
    text-align: center;
    font-size: 1.4rem;
    font-weight: bold;
    color: ${docketTheme.colors.white};
    border-radius: 100%;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12);
    background-color: ${({ envName }) =>
      (envName === "LOCAL" && `${docketTheme.colors.info} `) ||
      (envName === "INT" && "#800080") ||
      (envName === "TEST" && `${docketTheme.colors.success}`) ||
      (envName === "QA" && "#ff8e00") ||
      (envName === "STAGING" && "#b45309")};
  }
`
